import list from './country-list';

export default list.filter((country) => country.country_code === 'GB')[0] || null;
